import { DownloadOptions } from '../interfaces/DownloadOptions';

export const INITIAL_REPORT_OPTIONS: DownloadOptions = {
  details: true,
  messages: true,
  rfiMessages: true,
  audit: true,
  notes: true,
  actions: true,
  finalReport: true,
  files: true,
};

export const INITIAL_SELECTED_OPTION = 'Full Report';
export const CUSTOMIZE_SELECTED_OPTION = 'Customized Report';
